export function isValidPassport(value) {
  const regex = /^[A-Za-z0-9]{4,10}$/
  return regex.test(value)
}
